export const OWNER = {
  loginEmail: "owner-login-email",
  loginPassword: "owner-login-password",
  loginSubmit: "owner-login-submit",
  logout: "owner-logout-btn",
  navOverview: "nav-overview",
  navCreators: "nav-creators",
  navPurchases: "nav-purchases",
  navAudit: "nav-audit",
  navFraud: "nav-fraud",
  createCreatorBtn: "create-creator-btn",
  createCreatorSlug: "create-creator-slug",
  createCreatorName: "create-creator-name",
  createCreatorEmail: "create-creator-email",
  createCreatorCommission: "create-creator-commission",
  createCreatorSubmit: "create-creator-submit",
  createCreatorTebexCode: "create-creator-tebex-code",
  createLinkBtn: "create-link-btn",
  linkCampaignInput: "link-campaign-input",
  linkCreatorSelect: "link-creator-select",
  linkSubmit: "link-submit-btn",
  exportCreators: "export-creators-csv",
  exportPurchases: "export-purchases-csv",
  addPurchaseBtn: "add-purchase-btn",
  addPurchaseAmount: "add-purchase-amount",
  addPurchaseTx: "add-purchase-tx",
  addPurchaseDiscord: "add-purchase-discord",
  addPurchaseKind: "add-purchase-kind",
  addPurchaseSubmit: "add-purchase-submit",
  addPurchaseCreator: "add-purchase-creator",
  creatorRow: (slug) => `creator-row-${slug}`,
  editCreatorCommission: (slug) => `edit-creator-commission-${slug}`,
};

export const CREATOR = {
  loginBtn: "creator-discord-login-btn",
  dashboard: "creator-dashboard",
  metricsClicks: "creator-metric-clicks",
  metricsRevenue: "creator-metric-revenue",
  metricsEarnings: "creator-metric-earnings",
  logout: "creator-logout-btn",
};

export const LANDING = {
  heroCta: "landing-hero-cta",
  connectDiscord: "landing-connect-discord",
};
